module.exports = {"title":"Alejandro Oviedo","talk":"Demystifying (JavaScript) engines","path":"/speakers/alejandro-oviedo","type":"speaker","slug":"alejandro-oviedo","twitter":"a0viedo","github":"a0viedo","companyWebsite":"https://github.com/js-squad","company":"JSSquad","body":"<p>How a JavaScript engine works? What are its basic components? How to measure its performance? What is JIT compilation? Stigmatization: is JavaScript fast enough? are some of the questions I think we currently fail to answer in a, somewhat, short and direct way.</p>"}


/*****************
 ** WEBPACK FOOTER
 ** ./speakers/alejandro-oviedo.md
 ** module id = 486
 ** module chunks = 0
 **/